export default __webpack_public_path__ + "static/media/mentor.da188d8e.jpeg";